import * as Dialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { X } from 'lucide-react';

import { EnvironmentControl } from './EnvironmentSwitcher';
import { SidebarNav } from './SidebarNav';

interface MobileNavDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Mobile navigation as a slide-over drawer. Deliberately not a bottom tab bar —
 * there are ten top-level sections, which is far too many for tabs.
 */
export function MobileNavDrawer({ open, onOpenChange }: MobileNavDrawerProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay
          className="motion-safe:animate-mesh-fade fixed inset-0 z-100 md:hidden"
          style={{ background: 'var(--scrim)' }}
        />
        <Dialog.Content
          aria-label="Navigation"
          className="border-bd bg-bg-alt motion-safe:animate-mesh-slide-in fixed inset-y-0 left-0 z-110 flex w-[284px] max-w-[84vw] flex-col border-r shadow-[var(--shadow-lg)] md:hidden"
        >
          {/* The dialog's accessible name must describe its purpose, not the brand.
              The wordmark below is decorative; screen readers get "Navigation". */}
          <VisuallyHidden>
            <Dialog.Title>Navigation</Dialog.Title>
          </VisuallyHidden>

          <div className="border-bd flex h-14 flex-none items-center justify-between gap-2 border-b px-3.5">
            <div aria-hidden className="flex items-baseline gap-2">
              <span
                className="font-head text-tx text-[19px] font-bold uppercase"
                style={{ letterSpacing: '0.06em' }}
              >
                Mesh
              </span>
              <span
                className="font-head text-tx3 text-[13px] font-medium uppercase"
                style={{ letterSpacing: '0.16em' }}
              >
                Admin
              </span>
            </div>
            <Dialog.Close asChild>
              <button
                type="button"
                aria-label="Close navigation"
                className="border-bd bg-elev text-tx2 grid size-11 place-items-center rounded-lg border"
              >
                <X size={16} />
              </button>
            </Dialog.Close>
          </div>

          <SidebarNav expanded onNavigate={() => onOpenChange(false)} />

          <div className="border-bd flex-none border-t p-3">
            <EnvironmentControl className="w-full justify-center" />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
